(function( $ ) {

    $.fn.enableLoadingAnimation = function(enable) {

        this.filter('.dnButton').each(function() {

            if (enable) {
                $(this).addClass('dnButton-isLoading');
            } else {
                $(this).removeClass('dnButton-isLoading');
            }
        });

        return this;

    };

}( jQuery ));

window.onpageshow = function(event) {
    if (event.persisted) {
        $(document).find('.dnButton-isLoadable').enableLoadingAnimation(false);
    }
};
